import { createContext } from "react";

export default createContext({
    ticks: 0
});
